import {
    PhoenixDeployment,
    PhoenixDeploymentLinkGroup
} from 'phoenix/domain';

const DefaultPhoenixDeploymentLinkGroup: PhoenixDeploymentLinkGroup = {
    ApiPath: null,
    CreateUserGroup: null,
    Deployment: null,
    GetUserGroups: null
}

const DefaultPhoenixDeployment: PhoenixDeployment = {
    CustomerIdentifier: null,
    DatabaseName: null,
    DatabaseRootPath: null,
    DatabaseServer: null,
    DeploymentGroupName: null,
    DeploymentId: null,
    DiskgroupRootPath: null,
    DeploymentStatus: null,
    Links: {
        ApiPath: null,
        CreateUserGroup: null,
        Deployment: null,
        GetUserGroups: null
    },
    Name: null,
    SystemName: null
}

export enum DeploymentStatusFlags {
	Ok = 0,
    DatabaseUpgradeFailed = 0x0001,
    Inactive = 0x0002,
    DatabaseRollbackFailed = 0x0004,
}

export class Deployment {
	public static $inject = [
		'gettextCatalog'
	];

    public get deploymentId(): number {
        return this.deployment.DeploymentId
    }
    public set deploymentId(val) {
        this.deployment.DeploymentId = val;
    }
    
    public get customerIdentifier(): string {
        return this.deployment.CustomerIdentifier;
    }
    public set customerIdentifier(val) {
        this.deployment.CustomerIdentifier = val;
    };

    public get databaseName(): string {
        return this.deployment.DatabaseName;
    }
    public set databaseName(val) {
        this.deployment.DatabaseName = val;
    };
    
    public get databaseRootPath(): string {
        return this.deployment.DatabaseRootPath;
    }
    public set databaseRootPath(val) {
        this.deployment.DatabaseRootPath = val;
    };

    public get databaseServer(): string {
        return this.deployment.DatabaseServer;
    }
    public set databaseServer(val) {
        this.deployment.DatabaseServer = val;
    };
    
    public get deploymentGroupName(): string {
        return this.deployment.DeploymentGroupName;
    }
    public set deploymentGroupName(val) {
        this.deployment.DeploymentGroupName = val;
    };

    public get diskgroupRootPath(): string {
        return this.deployment.DiskgroupRootPath;
    }
    public set diskgroupRootPath(val) {
        this.deployment.DiskgroupRootPath = val;
    };

    public get deploymentStatusFlags(): number {
        return this.deployment.DeploymentStatus;
    }
    public set deploymentStatusFlags(val) {
        this.deployment.DeploymentStatus = val;
    };

    public get deploymentStatus() {
        return (this.deployment.DeploymentStatus & DeploymentStatusFlags.Inactive) ? 
                  this.gettextCatalog.getString('Deactivated') 
                : this.gettextCatalog.getString('Active');
    }

    private _links: DeploymentLinkGroup = null;
    public get links(): DeploymentLinkGroup {
        if(this._links == null) {
            this._links = new DeploymentLinkGroup(this.deployment.Links);
        }
        return this._links;
    }
    public set links(val) {
        this.deployment.Links = val.toApiObject();
    };
    
    public get name(): string {
        return this.deployment.Name;
    }
    public set name(val) {
        this.deployment.Name = val;
    };
    
    public get systemName(): string {
        return this.deployment.SystemName;
    }
    public set systemName(val) {
        this.deployment.SystemName = val;
    };

    constructor (
        private readonly gettextCatalog,
        private deployment: PhoenixDeployment = angular.copy(DefaultPhoenixDeployment)
    ) {
    }

    //TODO: create a generic utility function
    public getChangesForAPI(originalDeployment: Deployment)
    {
        if(originalDeployment === null || !angular.isDefined(originalDeployment)) {
            throw new Error('No original deployment to compare to.');
        }

        let updatedDeployment = this.toApiObject();
        let oldDeployment = originalDeployment.toApiObject();
        let changes:Partial<PhoenixDeployment> = {};

        changes = Object.keys(updatedDeployment)
            // filter keys down to the properties that are new or updated
            .filter((k) => {
                return angular.isDefined(updatedDeployment[k]) &&
                    (!(k in oldDeployment) || !angular.equals(updatedDeployment[k], oldDeployment[k])); 
            })
            .reduce((originalDiffSet, k) => {
                originalDiffSet[k] = updatedDeployment[k];
                return originalDiffSet;
            }, {});

        return changes;
    }

    public toApiObject(): PhoenixDeployment {
        return this.deployment;
    }
}

export class DeploymentLinkGroup {
    public get apiPath(): string {
        return this.deploymentLinkGroup.ApiPath;
    }
    public set apiPath(val) {
        this.deploymentLinkGroup.ApiPath = val;
    };

    public get createUserGroup(): string {
        return this.deploymentLinkGroup.CreateUserGroup;
    }
    public set createUserGroup(val) {
        this.deploymentLinkGroup.CreateUserGroup = val;
    };

    public get deployment(): string {
        return this.deploymentLinkGroup.Deployment;
    }
    public set deployment(val) {
        this.deploymentLinkGroup.Deployment = val;
    };

    public get getUserGroups(): string {
        return this.deploymentLinkGroup.GetUserGroups;
    }
    public set getUserGroups(val) {
        this.deploymentLinkGroup.GetUserGroups = val;
    };

    constructor(
        private deploymentLinkGroup: PhoenixDeploymentLinkGroup = angular.copy(DefaultPhoenixDeploymentLinkGroup)
    ) {
    }

    public toApiObject(): PhoenixDeploymentLinkGroup {
        return this.deploymentLinkGroup
    }
}


// WEBPACK FOOTER //
// ./src/sharebase/domain/deployment.ts